<ng-container
  *ngIf="{
    status: status$ | async,
  } as content"
>
  <div class="js-menu-mobile menu-mobile" [ngClass]="{ active: content.status }">
    <div class="header">
      <div class="container">
        <div class="content">
          <cx-page-slot position="SiteLogo"></cx-page-slot>

          <icon-hamburguer></icon-hamburguer>
        </div>
      </div>
    </div>

    <div class="js-menu-category-mobile menu-category-mobile">
      <cx-page-slot position="SiteLogin"></cx-page-slot>

      <cx-page-layout section="navigation"></cx-page-layout>
    </div>

    <div class="container">
      <cx-page-layout section="beforeHeader"></cx-page-layout>
    </div>
  </div>
</ng-container>
